import { useState } from "react";
import PropTypes from "prop-types";
import { StyledSelectableUpperUnits, StyledUpperUnitsInfo } from "../../../styles/StyledSelectableUpperUnits/StyledSelectableUpperUnits";
import { QueryLoader } from "../../Loader";
import { SelectableRadioUnit } from ".";

export default function SelectableSingleUnits({ data, isLoading, isError, error, setUnitSelectedID }) {
	const [selectedUnit, setSelectedUnit] = useState();

	const onChangeValue = (event) => {
		setSelectedUnit(event.target.value);
		setUnitSelectedID(event.target.value);
	};

	return isError ? (
		<p>{error}</p>
	) : isLoading ? (
		<StyledUpperUnitsInfo>
			<QueryLoader />
		</StyledUpperUnitsInfo>
	) : data.length > 0 ? (
		<StyledSelectableUpperUnits onChange={onChangeValue}>
			{data.map((el) => (
				<SelectableRadioUnit key={el.id} selectedUnit={selectedUnit} data={el} value={el.id.toString()} />
			))}
		</StyledSelectableUpperUnits>
	) : (
		<StyledUpperUnitsInfo>
			<p>No units found</p>
		</StyledUpperUnitsInfo>
	);
}

SelectableSingleUnits.propTypes = {
	data: PropTypes.array,
	isLoading: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	isError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	error: PropTypes.string,
	setUnitSelectedID: PropTypes.func,
};
